const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

export function captureAttribution() {
  try {
    if (localStorage.getItem('eam_attr')) return;
    const params = new URLSearchParams(window.location.search);
    const data = {};
    KEYS.forEach(k => { const v = params.get(k); if (v) data[k] = v; });
    if (document.referrer && !document.referrer.includes(window.location.hostname)) data.referrer = document.referrer;
    data.landing_page = window.location.pathname + window.location.search;
    data.first_seen_at = new Date().toISOString();
    localStorage.setItem('eam_attr', JSON.stringify(data));
  } catch { /* storage blocked — skip silently */ }
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem('eam_attr')) || null; } catch { return null; }
}
